import { useState, useEffect } from "react";
import { useAuthContext } from "./useAuthContext";

export const useUserRole = () => {
  const { user } = useAuthContext();
  const [role, setRole] = useState({
    isAdmin: false,
    isResTecnico: false,
    isBasicUser: true,
  });

  useEffect(() => {
    const checkUserRole = async () => {
      if (user) {
        try {
          // Ottieni il token ID aggiornato
          const idTokenResult = await user.getIdTokenResult(true);
          
          // Estrai i custom claims
          const customClaims = idTokenResult.claims;
          
          // Determina i ruoli in base ai custom claims
          const isAdmin = customClaims.admin === true;
          const isResTecnico = customClaims.resTecnico === true;
          
          // Imposta lo stato del ruolo
          setRole({
            isAdmin,
            isResTecnico,
            isBasicUser: !isAdmin && !isResTecnico,
          });
        } catch (error) {
          console.error("Errore durante il controllo del ruolo:", error);
          setRole({
            isAdmin: false,
            isResTecnico: false,
            isBasicUser: true,
          });
        }
      } else {
        // Resetta lo stato se non c'è un utente autenticato
        setRole({
          isAdmin: false,
          isResTecnico: false,
          isBasicUser: true,
        });
      }
    };

    checkUserRole();
  }, [user]);

  return role;
};